/**
 * Image Configuration File
 * This file serves as a central repository for all image paths used in the website.
 * Organize images by category for easy maintenance and updates.
 */

// No need to import images that are not used
// Just use direct paths for simplicity and consistency

// Banner Images
export const BANNERS = {
  HOME: "/assets/images/home/hero.jpg",
  ABOUT: "/assets/images/banners/about-banner.jpg",
  SERVICES: "/assets/images/banners/services-banner.jpg",
  CONTACT: "/assets/images/banners/contact-banner.jpg",
};

// About Page Images
export const ABOUT = {
  COMPANY_HISTORY: "/assets/images/about/company-history.jpg",
  MISSION: "/assets/images/about/mission.jpg",
  VISION: "/assets/images/about/vision.jpg",
};

// Service Images
export const SERVICES = {
  SECURITY: "/assets/images/services/security.jpg",
  HOUSEKEEPING: "/assets/images/services/housekeeping.jpg",
  SKILLED_LABOR: "/assets/images/services/skilled-labor.jpg",
  FACILITY_MANAGEMENT: "/assets/images/services/security.jpg", // Reusing security image
  SECURITY_GUARD: "/assets/images/services/security-guard.jpg",
  EVENT_SECURITY: "/assets/images/services/event-security.jpg",
  VIP_SECURITY: "/assets/images/services/vip-security.jpg",
};

// Home Page Images
export const HOME = {
  HERO: "/assets/images/home/hero.jpg",
  FEATURE_1: "/assets/images/services/security.jpg",
  FEATURE_2: "/assets/images/services/housekeeping.jpg",
  FEATURE_3: "/assets/images/services/skilled-labor.jpg",
  TESTIMONIAL_BG: "/assets/images/home/cta-background.jpg",
};

// Contact Page Images
export const CONTACT = {
  MAP: "/assets/images/contact/map.jpg",
  OFFICE: "/assets/images/contact/office.jpg",
};

// Team Images
export const TEAM = {
  MEMBER_1: "/assets/images/team/member-1.jpg",
  MEMBER_2: "/assets/images/team/member-2.jpg",
  MEMBER_3: "/assets/images/team/member-3.jpg",
  MEMBER_4: "/assets/images/team/member-4.jpg",
};

// Logo and Icons - Using direct URL paths 
export const LOGOS = {
  // Using the logo from public folder with absolute paths
  PRIMARY: "/logo192.png",
  FOOTER: "/logo192.png",
  FAVICON: "/favicon.ico",
};

// Export all image categories as a named object to fix the ESLint warning
export const imageConfig = {
  BANNERS,
  ABOUT,
  SERVICES,
  HOME,
  CONTACT,
  TEAM,
  LOGOS,
};

export default imageConfig; 